import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Approval Flow pages
export const ApprovalFlowListPage = lazy(
  () =>
    retry(() => import('@pages/settings/approval-flows/list')) as Promise<
      typeof import('@pages/settings/approval-flows/list')
    >
);

export const ApprovalFlowEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/approval-flows/edit')) as Promise<
      typeof import('@pages/settings/approval-flows/edit')
    >
);

export const ApprovalFlowCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/approval-flows/create')) as Promise<
      typeof import('@pages/settings/approval-flows/create')
    >
);

// AF New User pages
export const AFNewUserListPage = lazy(
  () =>
    retry(() => import('@pages/settings/af-new-user/list')) as Promise<
      typeof import('@pages/settings/af-new-user/list')
    >
);

export const AFNewUserEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/af-new-user/edit')) as Promise<
      typeof import('@pages/settings/af-new-user/edit')
    >
);

export const AFNewUserCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/af-new-user/create')) as Promise<
      typeof import('@pages/settings/af-new-user/create')
    >
);

// Billing Order pages
export const BillingOrderListPage = lazy(
  () =>
    retry(() => import('@pages/settings/billing-orders/list')) as Promise<
      typeof import('@pages/settings/billing-orders/list')
    >
);

export const BillingOrderEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/billing-orders/edit')) as Promise<
      typeof import('@pages/settings/billing-orders/edit')
    >
);

export const BillingOrderCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/billing-orders/create')) as Promise<
      typeof import('@pages/settings/billing-orders/create')
    >
);
